import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateDeclaracionJuradaCeseActividadObjetiva = () => {
  const [loadingCreateDeclaracionJuradaCeseActividadObjetiva, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCreateDeclaracionJuradaCeseActividadObjetiva, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCreateDeclaracionJuradaCeseActividadObjetiva, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCreateDeclaracionJuradaCeseActividadObjetiva, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createDeclaracionJuradaCeseActividadObjetiva = async (userId:string , data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newSolicitudDeclaracionJuradaObjetiva(userId, data).then((res: any) => {
      setLoadingCreateSolicitudPagoDirecto(false);
      setSuccessCreateSolicitudPagoDirecto(true);
      setDataSolicitudPagoDirecto(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudPagoDirecto(false);
      setErrorCreateSolicitudPagoDirecto(err.response.data)
    })
  }




  return {
    createDeclaracionJuradaCeseActividadObjetiva,
    loadingCreateDeclaracionJuradaCeseActividadObjetiva,
    successCreateDeclaracionJuradaCeseActividadObjetiva,
    errorCreateDeclaracionJuradaCeseActividadObjetiva,
    dataCreateDeclaracionJuradaCeseActividadObjetiva
  }

}

export default useCreateDeclaracionJuradaCeseActividadObjetiva;
